
export const SOLACE_CONSUME_EVENTS_SUCCESS = `SOLACE_CONSUME_EVENTS_SUCCESS`

export const SOLACE_CONSUME_EVENTS_FAILURE = `SOLACE_CONSUME_EVENTS_FAILURE`


export const consumeSolaceEventsSuccess = (payload:any): any => {
	return {
		type: SOLACE_CONSUME_EVENTS_SUCCESS,
		payload
	}
}


export const consumeSolaceEventsFailure = (payload:any): any => {
	return {
		type: SOLACE_CONSUME_EVENTS_FAILURE,
		payload
	}
}